"use strict";
function fromCallback(fn) {
    return new Promise(function (resolve, reject) {
        fn(function (err, result) {
            if (err)
                reject(err);
            else
                resolve(result);
        });
    });
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fromCallback;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/promise-cb/from.js
// module id = 947
// module chunks = 73